import * as React from 'react';

import {
  DeviceSelector,
  DeviceSelectorButton,
  DeviceSelectorIconPC,
  DeviceSelectorIconSP,
} from './style';

interface VotingSelectDeviceProps {
  handleClickSP: () => void;
  handleClickPC: () => void;
}

const VotingSelectDevice: React.FC<VotingSelectDeviceProps> = ({
  handleClickSP,
  handleClickPC,
}) => {
  return (
    <DeviceSelector>
      <DeviceSelectorButton onClick={handleClickSP}>
        <DeviceSelectorIconSP />
        スマートフォン
      </DeviceSelectorButton>
      <DeviceSelectorButton onClick={handleClickPC}>
        <DeviceSelectorIconPC />
        パソコン
      </DeviceSelectorButton>
    </DeviceSelector>
  );
};

export default VotingSelectDevice;
